angular.module('unergie.main')
.controller('overduesCtrl', ($scope, $state, AccountService, AlertManager, DataAccess, ApiUser,
    AdminComments, ReferencesService, BoFeaturesService, ErrorCatcher, TableGeneratorService, OverdueProcessUtilsService, ModalService) => {
    const feats = BoFeaturesService.getModuleFeatures('overdues')
    $scope.adminLink = feats.adminLink
    const contractFeats = BoFeaturesService.getModuleFeatures('contracts')
    $scope.userCanReducOutage = contractFeats.canReducOutage

    $scope.modes = ['overdues', 'overduesNoProcess']
    $scope.mode = $scope.modes[0]

    $scope.fslStatusMapping = {
        FSL_REQUEST: { color: 'dark-green', display: 'En cours', tooltip: 'Une demande de FSL est en cours (FSL_REQUEST)' },
        FSL_LAST_YEAR: { color: 'dark-pink', display: 'Récente', tooltip: `Une demande de FSL a été accordée il y a moins d'un an (FSL_LAST_YEAR)` },
        NO_FSL: { color: 'bluegrey', display: 'Non', tooltip: 'Pas de demande de FSL (NO_FSL)' },
    }

    $scope.overdues = {
        show: {},
        columns: {
            'selector': { label: 'Selection', mode: 'filter_only' },
            'id': { label: 'Id', mode: 'hidden', mandatory: true },
            'process_name': { label: 'Process', mode: 'search_wildcard', mandatory: true },
            'fullname': { label: 'Client', mode: 'search_wildcard', mandatory: true },
            'id_contract': { label: 'Id contrat', mode: 'search_wildcard', length: 9, mandatory: true },
            'simpleStatus': { label: 'Statut', mode: 'filter_only', isVisible: false, mandatory: true },
            'step': { label: 'Étape', mode: 'filter_only', isVisible: false, mandatory: true },
            'process_status': { label: 'Statut brut', mode: 'search_wildcard', mandatory: true },
            'contract_status': { label: 'Statut contrat', mode: 'search_operator', mandatory: true },
            'start_date': { label: 'Date de début', mode: 'search_date', isVisible: false, mandatory: true },
            'next_step_date': { label: 'Prochaine date', mode: 'search_date', isVisible: false, mandatory: true },
            'energy_check_validity': { label: 'Chèque énérgie', mode: 'filter_only', mandatory: true },
            'energy_check_validity_date': { label: 'Date chèque énérgie', mode: 'search_date', isVisible: false, mandatory: true },
            'fsl_status': { label: 'FSL', mode: 'search_operator', mandatory: true },
            'owed': { label: 'Dû', mode: 'search_operator', isVisible: false, mandatory: true },
            'paid': { label: 'Payé', mode: 'search_operator', isVisible: false, mandatory: true },
            'planned': { label: 'Planifié', mode: 'search_operator', isVisible: false, mandatory: true },
            'pending': { label: 'En cours', mode: 'search_operator', isVisible: false, mandatory: true },
            'burned': { label: 'Cagnotte utilisée', mode: 'search_operator', isVisible: false, mandatory: true },
            'to_recover': { label: 'Reste à percevoir', mode: 'search_operator', isVisible: false, mandatory: true },
            'total_paid': { label: 'Total payé', mode: 'search_operator', isVisible: false, mandatory: true },
            'balance': { label: 'Solde', mode: 'search_operator', mandatory: true },
            'payment_rate': { label: 'Taux de paiement', mode: 'search_operator', mandatory: true },
            'nb_case_rif': { label: 'Nb affaires résil. fourn.', mode: 'search_operator', mandatory: true },
            'nb_case_sai_rpi': { label: 'Nb affaires coup./limit.', mode: 'search_operator', mandatory: true },
            'suspension_status': { label: 'État coupure', mode: 'search_wildcard', mandatory: true },
            'communicating': { label: 'Compteur communicant', mode: 'search_wildcard', mandatory: true },
            'account.category': { label: 'Categorie du compte', mode: 'hidden', mandatory: true },
        },
    }

    $scope.overduesNoProcess = {
        show: {},
        columns: {
            'account.fullname': { label: 'Client', mode: 'search_wildcard', mandatory: true },
            'id': { label: 'Id contrat', mode: 'search_wildcard', length: 9, mandatory: true },
            'status': { label: 'Statut contrat', mode: 'search_operator', mandatory: true },
            'balance': { label: 'Solde', mode: 'search_operator', mandatory: true },
        },
    }

    const transformData = (data) =>
        data.forEach((overdue) => {
            if (overdue.energy_check_validity_date) {
                overdue.energy_check_validity = moment(overdue.energy_check_validity_date).isAfter(new Date()) ? 'Valide' : 'Périmé'
                overdue.energy_check_validity_color = moment(overdue.energy_check_validity_date).isAfter(new Date()) ? 'dark-green' : 'dark-pink'
            } else {
                overdue.energy_check_validity = 'Non'
                overdue.energy_check_validity_color = 'bluegrey'
            }
            if ($scope.mode === 'overdues') {
                const display = OverdueProcessUtilsService.getOverdueStatusMapping(overdue.process_status)
                overdue.simpleStatus = display.simpleStatus
                overdue.step = display.step
                overdue.statusColor = display.color
            }
        })


    $scope.refresh = function () {
        if ($scope.mode === 'overdues') {
            TableGeneratorService.getTable($scope.overdues, 'vw-overdue-process-context', null, transformData, { orderBy: '-next_step_date' })
            $scope.tableInstance = $scope.overdues
            return $scope.tableInstance
        }
        TableGeneratorService.getTable($scope.overduesNoProcess, 'contracts-od-no-process', 'account', transformData)
        $scope.tableInstance = $scope.overduesNoProcess
        return $scope.tableInstance
    }

    $scope.refresh()

    $scope.isActive = (state) => $state.is(state)

    $scope.showButtons = function (overdue) {
        if ($scope.mode === 'overdues') {
            return (overdue.process_status.indexOf('CANCELLED_') === -1) && (overdue.process_status.indexOf('FINISHED_') === -1) && (overdue.process_status !== 'TERMINATION_NOTIF_SENT')
        }
        return false
    }

    $scope.canTerminate = function (overdue) {
        if ($scope.mode === 'overdues') {
            return ($scope.userCanReducOutage
                && overdue.process_status === 'STARTED_REDUC_OUTAGE_PROCESS'
                && overdue.balance < 0
            )
        }
        return false
    }

    $scope.openTerminationModal = (overdue) => {
        $scope.limiting = true
        const energy_check_validity = !!overdue.energy_check_validity_date && moment(overdue.energy_check_validity_date).add(30, 'days').isAfter(new Date())

        return DataAccess.contractElecInfoLight({ id_account: overdue.id_account, id_contract: overdue.id_contract }).$promise
        .then((contractElec) => {
            return ModalService.openModal({ type: 'contractTerminationModal', size: 'lg' }, { contractElec, pro: overdue.category !== 'part', energy_check_validity, overdueOnly: true },
                () => $scope.refresh())
        }).finally(() => {
            $scope.limiting = false
        })
    }

    $scope.delayFields = {
        wait_until: {
            label: 'Jusqu\'au',
            type: 'date',
        },
    }

    $scope.setWaitUntil = (overdue) => {
        overdue.wait_until = moment().toDate()
        return overdue.wait_until
    }

    $scope.delayProcess = (overdue) =>
        ApiUser.delayOverdue({ id: overdue.id }, { wait_until: moment(overdue.wait_until).format('YYYY-MM-DD') }).$promise.then(() =>
            AlertManager.success('Processus mis en pause'))
        .catch(ErrorCatcher)
        .finally(() => $scope.refresh())



    $scope.cancelProcess = (overdue) =>
        ApiUser.cancelOverdue({ id: overdue.id }).$promise.then(() =>
            AlertManager.success('Processus annulé'))
        .catch(ErrorCatcher)
        .finally(() => $scope.refresh())

    $scope.killProcess = (overdue) =>
        ApiUser.killOverdueProcess({ id: overdue.id }).$promise.then(() =>
            AlertManager.success('Processus supprimé'))
        .catch(ErrorCatcher)
        .finally(() => $scope.refresh())


    $scope.changeMode = function () {
        const actualIndex = _.indexOf($scope.modes, $scope.mode)
        $scope.mode = $scope.modes[(actualIndex + 1) % $scope.modes.length]
        return $scope.refresh()
    }

    $scope.launching = {}

    $scope.overduePayload = {}

    $scope.overdueFields = {
        start_date: {
            label: 'Date de 1er impayé',
            type: 'date',
        },
        bypass: {
            label: 'Court-circuit',
            type: 'select',
            enum: [
                { label: 'Pas de court-circuit', value: '0' },
                { label: 'Avant vérification chèque énergie', value: '2' },
                { label: 'Avant LRAR', value: 'energy_check' },
                { label: 'Avant limitation/coupure', value: '3' },
            ],
        },
    }

    $scope.terminatedOverdueFields = {
        start_date: {
            label: 'Date de paiement la facture',
            type: 'date',
        },
    }

    $scope.updateOverduePayload = (contractElec) => {
        $scope.overduePayload = {
            id_contract: contractElec.id,
            start_date: moment().toDate(),
            bypass: '0',
        }
        return $scope.overduePayload
    }



    $scope.showTerminatedOverdueButton = (overdue) => overdue.status === 4

    $scope.launchOverdue = function () {
        $scope.launching[$scope.overduePayload.id_contract] = true
        const payload = angular.copy($scope.overduePayload)
        payload.start_date = moment(payload.start_date).format('YYYY-MM-DD')
        return ApiUser.startOverdue(payload).$promise.then(() => {
            AlertManager.success('Processus d\'impayé démarré')
            const sound = new Audio('/sounds/slap.mp3')
            sound.play()
            return $scope.refresh() }).catch(ErrorCatcher)
        .finally(() => {
            $scope.launching[$scope.overduePayload.id_contract] = false
            return $scope.launching[$scope.overduePayload.id_contract]
        })
    }

    $scope.launchTerminatedOverdue = function () {
        $scope.launching[$scope.overduePayload.id_contract] = true
        const payload = angular.copy($scope.overduePayload)
        payload.start_date = moment(payload.start_date).format('YYYY-MM-DD')
        return ApiUser.startTerminatedOverdue(payload).$promise.then(() => {
            AlertManager.success('Processus d\'impayé post-résiliation démarré')
            const sound = new Audio('/sounds/slap.mp3')
            sound.play()
            return $scope.refresh() }).catch(ErrorCatcher)
        .finally(() => {
            $scope.launching[$scope.overduePayload.id_contract] = false
            return $scope.launching[$scope.overduePayload.id_contract]
        })
    }

    $scope.toggleSelected = (overdue) => {
        if ($scope.canTerminate(overdue)) {
            overdue.selected = !overdue.selected
        }
    }

    $scope.selectAll = () => _.forEach($scope.overdues.instance.data, (o) => { if ($scope.canTerminate(o)) { o.selected = true } })

    $scope.deSelectAll = () => _.forEach($scope.overdues.instance.data, (o) => { if ($scope.canTerminate(o)) { o.selected = false } })

    $scope.getSelectedNumber = () => _.countBy($scope.overdues.instance.data, 'selected').true || 0

    $scope.massSuspend = () => {
        $scope.massSuspending = true
        const overduesToSuspend = _.filter($scope.overdues.instance.data, (o) => o.selected)

        return ApiUser.massSuspendContract({ contractList: _.map(overduesToSuspend, 'id_contract') }).$promise.then((result) => {
            return AlertManager.success(`Batch de coupure traité avec succès`)
        }).catch(ErrorCatcher).finally(() => {
            $scope.refresh()
            $scope.massSuspending = false
        })
    }

    $scope.massReduce = () => {
        $scope.massReducing = true
        const overduesToReduce = _.filter($scope.overdues.instance.data, (o) => o.selected)

        return ApiUser.massReduceContract({ contractList: _.map(overduesToReduce, 'id_contract') }).$promise.then((result) => {
            return AlertManager.success(`Batch de limitation traité avec succès`)
        }).catch(ErrorCatcher).finally(() => {
            $scope.refresh()
            $scope.massReducing = false
        })
    }

    return $scope.launchTerminatedOverdue
})
